import React, { ReactNode, useEffect } from 'react';
import { useProfilesLocalStorage } from '../../ProfilesLocalStorageContext';
import { useNavigateWithHistory } from '../useNavigateWithHistory';
import { LOGIN_ONBOARDING_PATH } from '../routeNames';
import { useSearchParams } from 'react-router-dom';

const LoginOnboardingRedirect: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { profiles } = useProfilesLocalStorage();
  const navigate = useNavigateWithHistory();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!profiles.length) {
      navigate(`/${LOGIN_ONBOARDING_PATH}?${searchParams.toString()}`);
    }
  }, [navigate, profiles.length, searchParams]);

  return profiles.length ? children : null;
};

export default LoginOnboardingRedirect;
